import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Check if app is Acquired
 * @param {object} params - an object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.versionId - versionId of the app
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['versionId', 'accessToken'];
  const paramsRules = {
    versionId: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${settings.endpoint}/v1/downloadUrl?appVersionId=${params.versionId}`, {
    signal,
    headers: { Authorization: params.accessToken, 'x-api-key': settings.apiKey },
  });
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
